import { render, staticRenderFns } from "./agentorg.vue?vue&type=template&id=3a0ca099&scoped=true"
import script from "./agentorg.vue?vue&type=script&lang=js"
export * from "./agentorg.vue?vue&type=script&lang=js"
import style0 from "./agentorg.vue?vue&type=style&index=0&id=3a0ca099&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0ca099",
  null
  
)

export default component.exports